<script setup>
import { ref, onBeforeUnmount, onMounted } from 'vue'
import eventBus from '@core/utils/eventBus'
import { setDomFontSize } from '@core/utils/index.js'
import { initUserStore, useUserStore } from '@core/store/user.js'
import PayView from '@components/iframeView/pay.vue'
import { initGameStore } from '@core/store/game.js'
import { initVipStore } from '@core/store/vip.js'
import { initConfigStore, useConfigStore } from '@core/store/config.js'
import { useSocket } from '@core/socket/core.js'
import { registerLobbyPopupRouteHook, showWithdrawVipRequiredWithDailyLimit, suppressLobbyPopupsOnce } from '@core/utils/lobbyPopupController.js'
import { showWithdrawVip1Limit } from '@components/popup/gameBack/index.js'
import { traceEvent } from '@core/utils/fbq.js'
import router from '@core/router/index.js'
import { showJackpot } from '@components/popup/jackpot/index.js'

initConfigStore()
initUserStore()
initVipStore()
initGameStore()

const iframeMessage = event => {
  eventBus.emit('iframeMessage', event)
}

const socket = ref(null)

const userStore = useUserStore()
const configStore = useConfigStore()

const loginSuccess = () => {
  if (!socket.value?.isOpen || !userStore.isLogin) return
  socket.value.sendMessage(
    JSON.stringify({
      cmd: 'login',
      data: userStore.user.token,
    }),
  )
}

const initWebSocket = () => {
  socket.value = useSocket()
  socket.value.subscribe('open', () => {
    console.info('WebSocket连接成功!')
    loginSuccess()
  })

  socket.value.subscribe('message', (result) => {
    try {
      const data = JSON.parse(result)
      const cmd = data.cmd

      console.log('cmd:', cmd, 'data:', data.data)

      if (cmd === 'roundid') {
        const result = JSON.parse(data.data)
        eventBus.emit('roundid', result.roundid)
      }

      // 充值完成
      if (cmd === 'charge_success') {
        userStore.freshBalance()
        // result = { pay: Number, firstpay: Boolean, orderId: String }
        const result = JSON.parse(data.data)
        const event = result.firstpay ? 'first_pay_event' : 'routine_pay_event'
        const traceParams = {}
        if (result.pay >= 0.001) {
          traceParams.revenue = result.pay
          traceParams.currency = configStore.currency
        }
        if (result.orderId) {
          traceParams.orderId = result.orderId
        }
        traceEvent(event, traceParams)

        if (result.firstpay && router.currentRoute.value.path !== '/game') {
          router.push('/')
          showJackpot()
        }
      }

      if (cmd === 'otherlogin') {
        userStore.logout()
      }

      // 新手限制：关闭游戏并引导充值
      if (cmd === 'beginer_limit') {
        const fromGame = router.currentRoute.value.path === '/game'
        if (fromGame) {
          suppressLobbyPopupsOnce()
          router.push('/')
        }
        void showWithdrawVipRequiredWithDailyLimit()
      }

      // VIP1 达到最低提现门槛：游戏内弹窗，不关闭游戏
      if (cmd === 'vip1_limit') {
        void showWithdrawVip1Limit()
      }
    } catch (e) {}
  })

  socket.value.subscribe('reconnect', (_socket) => {
    console.info('WebSocket断开重连:', _socket)
    socket.value = _socket
  })
}

onMounted(async () => {
  registerLobbyPopupRouteHook()
  initWebSocket()
  window.addEventListener('resize', setDomFontSize)
  window.addEventListener('message', iframeMessage)
  eventBus.on('loginSuccess', loginSuccess)
})

onBeforeUnmount(() => {
  window.removeEventListener('resize', setDomFontSize)
  window.removeEventListener('message', iframeMessage)
  eventBus.off('loginSuccess', loginSuccess)
})
</script>

<template>
  <div class="router-view relative">
    <router-view v-slot="{ Component }">
      <KeepAlive>
        <component :is="Component"/>
      </KeepAlive>
    </router-view>

  </div>

  <pay-view/>
</template>

<style lang="scss">
.router-view {
  height: 100%;
  overflow-x: hidden;
  transform: translateZ(0);
}
</style>
